import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { BreadcrumbsComponent } from '../../shared/partials/breadcrumbs/breadcrumbs.component'
import { NewsletterFormComponent } from '../../shared/partials/newsletter-form/newsletter-form.component'
import { PaginationComponent } from '../../shared/partials/pagination/pagination.component'
import { SocialShareComponent } from '../../shared/partials/social-share/social-share.component'
import { AuthorCardComponent } from '../../shared/resources/author/author-card/author-card.component'
import { AuthorDisclaimerComponent } from '../../shared/resources/author/author-disclaimer/author-disclaimer.component'
import { DocumentListComponent } from '../../shared/resources/document/document-list/document-list.component'
import { PostCardComponent } from '../../shared/resources/post/post-card/post-card.component'
import { WorkingGroupCardComponent } from '../../shared/resources/working-group/working-group-card/working-group-card.component'
import { AiWonkBlogRoutingModule } from './ai-wonk-blog.routes'
import { BlogIndexComponent } from './pages/blog-index/blog-index.component'
import { AiPrincipleDetailComponent } from './resources/ai-principle/ai-principle-detail/ai-principle-detail.component'
import { CountryComponent } from './resources/country/country.component'
import { DocumentDetailComponent } from './resources/document/document-detail/document-detail.component'
import { PolicyAreaDetailComponent } from './resources/policy-area/policy-area-detail/policy-area-detail.component'
import { PostDetailComponent } from './resources/post/post-detail/post-detail.component'
import { TagDetailComponent } from './resources/tag/tag-detail/tag-detail.component'

@NgModule({
  declarations: [
    BlogIndexComponent,
    CountryComponent,
    DocumentDetailComponent,
    PostDetailComponent,
    BlogIndexComponent,
    TagDetailComponent,
    PolicyAreaDetailComponent,
    TagDetailComponent,
    AiPrincipleDetailComponent
  ],
  imports: [
    CommonModule,
    AiWonkBlogRoutingModule,
    ReactiveFormsModule,

    // Standalone
    PostCardComponent,
    BreadcrumbsComponent,
    AuthorDisclaimerComponent,
    AuthorCardComponent,
    WorkingGroupCardComponent,
    NewsletterFormComponent,
    DocumentListComponent,
    SocialShareComponent,
    PaginationComponent
  ]
})
export class AiWonkBlogModule {}
